export var Outline;
(function (Outline) {
    Outline["I"] = "i";
    Outline["ID"] = "id";
    Outline["E"] = "e";
    Outline["ED"] = "ed";
    Outline["EP"] = "ep";
    Outline["NA"] = "N/A";
    Outline["PH"] = "ph";
})(Outline || (Outline = {}));
